import useTouchDrag from './useTouchDrag.js';
import useMouseDrag from './useMouseDrag.js';

var useDrag = function useDrag(target, onDrag) {
  var isTouchDragging = useTouchDrag(target, onDrag);
  var isMouseDragging = useMouseDrag(target, onDrag);
  return isTouchDragging || isMouseDragging;
};

export { useDrag as default };
//# sourceMappingURL=useDrag.js.map
